<section class="section-title" [style.background-image]="backgroundImage">

    <div class="section-title-image">
        <img class="device-image" src="assets/img/device-pilomat.png" />
    </div>

    <div class="section-title-text">
        <h1 i18n="@@programmed_executions_title">Automatismi</h1>

    </div>

</section>

<section class="section-content">

    <mat-tab-group [animationDuration]="'0ms'">

        <mat-tab label={{programmedExecutionsString}}>
            <app-programmed-executions [filter]="filterString" [userCanExecutionEdit]="userCanExecutionEdit">
            </app-programmed-executions>
        </mat-tab>

        <mat-tab label={{periodicExecutionsString}}>
            <app-periodic-executions [filter]="filterString" [userCanExecutionEdit]="userCanExecutionEdit">
            </app-periodic-executions>
        </mat-tab>


        <mat-tab *ngIf="hasV123" label={{automationsString}}>
            <app-automations [filter]="filterString" [userCanExecutionEdit]="userCanExecutionEdit">
            </app-automations>
        </mat-tab>

    </mat-tab-group>

</section>

  <app-loading-screen #executionsLoader [loading]="false"></app-loading-screen>
